import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instancep7dfbo63nk35 as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.y4g_1 = 8192;
        this.z4g_1 = 1024;
      }
      a4h() {
        return Segment().b4h();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.z4e_1 = 0;
  _this__u8e3s4.a4f_1 = 0;
  _this__u8e3s4.b4f_1 = null;
  _this__u8e3s4.c4f_1 = false;
  _this__u8e3s4.d4f_1 = null;
  _this__u8e3s4.e4f_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      d4g() {
        var tmp0_safe_receiver = this.b4f_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c4h();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static b4h() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.y4e_1 = new Int8Array(8192);
        $this.c4f_1 = true;
        $this.b4f_1 = null;
        return $this;
      }
      static d4h(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.y4e_1 = data;
        $this.z4e_1 = pos;
        $this.a4f_1 = limit;
        $this.b4f_1 = shareToken;
        $this.c4f_1 = owner;
        return $this;
      }
      l4f() {
        var tmp0_elvis_lhs = this.b4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.e4h();
          this.b4f_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.z4e_1;
        var tmp_1 = this.a4f_1;
        // Inline function 'kotlin.also' call
        t.f4h();
        return Segment().d4h(this.y4e_1, tmp_0, tmp_1, t, false);
      }
      g4g() {
        var result = this.d4f_1;
        if (!(this.e4f_1 == null)) {
          ensureNotNull(this.e4f_1).d4f_1 = this.d4f_1;
        }
        if (!(this.d4f_1 == null)) {
          ensureNotNull(this.d4f_1).e4f_1 = this.e4f_1;
        }
        this.d4f_1 = null;
        this.e4f_1 = null;
        return result;
      }
      m4f(segment) {
        segment.e4f_1 = this;
        segment.d4f_1 = this.d4f_1;
        if (!(this.d4f_1 == null)) {
          ensureNotNull(this.d4f_1).e4f_1 = segment;
        }
        this.d4f_1 = segment;
        return segment;
      }
      e4g(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.a4f_1 - this.z4e_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().s2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.l4f();
        } else {
          prefix = SegmentPool_instance.m3w();
          var tmp0 = this.y4e_1;
          var tmp2 = prefix.y4e_1;
          var tmp5 = this.z4e_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.z4e_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.a4f_1 = prefix.z4e_1 + byteCount | 0;
        this.z4e_1 = this.z4e_1 + byteCount | 0;
        if (!(this.e4f_1 == null)) {
          ensureNotNull(this.e4f_1).m4f(prefix);
        } else {
          prefix.d4f_1 = this;
          this.e4f_1 = prefix;
        }
        return prefix;
      }
      n4f() {
        // Inline function 'kotlin.check' call
        if (!!(this.e4f_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.e4f_1).c4f_1)
          return this;
        var byteCount = this.a4f_1 - this.z4e_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.e4f_1).a4f_1 | 0) + (ensureNotNull(this.e4f_1).d4g() ? 0 : ensureNotNull(this.e4f_1).z4e_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.e4f_1;
        this.f4g(ensureNotNull(predecessor), byteCount);
        var successor = this.g4g();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        SegmentPool_instance.n4g(this);
        return predecessor;
      }
      j4g(byte) {
        var _unary__edvuaz = this.a4f_1;
        this.a4f_1 = _unary__edvuaz + 1 | 0;
        this.y4e_1[_unary__edvuaz] = byte;
      }
      l4g(short) {
        var data = this.y4e_1;
        var limit = this.a4f_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.a4f_1 = limit;
      }
      g4f() {
        var _unary__edvuaz = this.z4e_1;
        this.z4e_1 = _unary__edvuaz + 1 | 0;
        return this.y4e_1[_unary__edvuaz];
      }
      i4f() {
        var data = this.y4e_1;
        var pos = this.z4e_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.z4e_1 = pos;
        return s;
      }
      f4g(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.c4f_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.a4f_1 + byteCount | 0) > 8192) {
          if (sink.d4g())
            throw IllegalArgumentException().xd();
          if (((sink.a4f_1 + byteCount | 0) - sink.z4e_1 | 0) > 8192)
            throw IllegalArgumentException().xd();
          var tmp0 = sink.y4e_1;
          var tmp2 = sink.y4e_1;
          var tmp5 = sink.z4e_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.a4f_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.a4f_1 = sink.a4f_1 - sink.z4e_1 | 0;
          sink.z4e_1 = 0;
        }
        var tmp0_0 = this.y4e_1;
        var tmp2_0 = sink.y4e_1;
        var tmp4 = sink.a4f_1;
        var tmp6 = this.z4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.z4e_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.a4f_1 = sink.a4f_1 + byteCount | 0;
        this.z4e_1 = this.z4e_1 + byteCount | 0;
      }
      r4f(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.y4e_1;
        var tmp6 = this.z4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.z4e_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.z4e_1 = this.z4e_1 + len | 0;
      }
      b4g(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.y4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.a4f_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.a4f_1 = this.a4f_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      v2() {
        return this.a4f_1 - this.z4e_1 | 0;
      }
      a4g() {
        return this.y4e_1.length - this.a4f_1 | 0;
      }
      g4h(readOnly) {
        return this.y4e_1;
      }
      p4f(index) {
        return this.y4e_1[this.z4e_1 + index | 0];
      }
      h4h(index, value) {
        this.y4e_1[this.a4f_1 + index | 0] = value;
      }
      i4h(index, b0, b1) {
        var d = this.y4e_1;
        var l = this.a4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      j4h(index, b0, b1, b2) {
        var d = this.y4e_1;
        var l = this.a4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      k4h(index, b0, b1, b2, b3) {
        var d = this.y4e_1;
        var l = this.a4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.v2() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      c4h() {
        return true;
      }
      f4h() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.v2() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().s2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.v2() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().s2(toString(message_0));
  }
  var p = _this__u8e3s4.z4e_1;
  var data = _this__u8e3s4.g4h(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance35mam6kufibag,
  Companion_instance as Companion_instance1evlhu73xfb8l,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
